import React, { useState, useEffect } from 'react';
import { Logo } from './Logo';

export const SplashScreen: React.FC = () => {
  // Auth loading messages
  const authLoadingMessages = [
    'Tracking the herd...',
    'Packing the jeep...',
    'Spotting lions...',
    'Crossing the savannah...',
    'Scouting for adventure...',
    'Kicking up safari dust...',
    'Binoculars up...',
    'Following elephant tracks...',
    'Setting up camp...',
    'Roaring into action...',
  ];

  const [currentMessageIndex, setCurrentMessageIndex] = useState(() =>
    Math.floor(Math.random() * authLoadingMessages.length)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex(prev => (prev + 1) % authLoadingMessages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [authLoadingMessages.length]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      <div className="flex flex-col items-center">
        {/* Auth loading with logo in spinning circle */}
        <div className="relative w-20 h-20 sm:w-28 sm:h-28">
          <div className="w-20 h-20 sm:w-28 sm:h-28 border-2 sm:border-3 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
          <div className="absolute inset-0 flex items-center justify-center">
            <Logo 
              variant="default" 
              width={56} 
              height={56} 
              className="sm:w-20 sm:h-20 opacity-80"
            />
          </div>
        </div>
        
        <p className="mt-2 text-gray-600 text-sm">
          {authLoadingMessages[currentMessageIndex]}
        </p>
      </div>
    </div>
  );
}; 